import fsboCover from "@/assets/book-fsbo.png";
import expiredCover from "@/assets/book-expired.png";
import topDollarCover from "@/assets/book-top-dollar.png";
import buyingCover from "@/assets/book-buying.png";
import downsizeCover from "@/assets/book-downsize.png";

/** John's GHL calendar (Free Real Estate Consultation, Align Right Realty). */
export const CALENDAR_URL = "https://api.upsurgepros.com/widget/booking/6Ka5Qi7JJH1PcoCZjJkP";

/**
 * GHL Inbound Webhook (Align Right Realty sub-account) that receives free-book requests.
 * The workflow behind it creates/updates the contact, tags it by book and notifies John.
 */
export const GHL_BOOK_WEBHOOK_URL =
  "https://services.leadconnectorhq.com/hooks/M0BPIkwoEnXHbrhboNqc/webhook-trigger/53d12516-3803-4e12-9571-5a690c08389c";

export type BookKey = "fsbo" | "expired" | "top-dollar" | "buying" | "downsize";

export interface Book {
  key: BookKey;
  title: string;
  audience: string;
  description: string;
  cover: string;
  coverWidth: number;
  coverHeight: number;
  /** John's form-free flipbook page on johnmastroianni.book.live. */
  readUrl: string;
  /** Tag the GHL workflow applies to the contact. */
  tag: string;
  /** Cover is an open front-and-back spread (landscape), shown as-is. */
  spread?: boolean;
}

export const BOOKS: Book[] = [
  {
    key: "fsbo",
    title: "Secrets for Selling Your Home Alone",
    audience: "FSBO Sellers",
    description:
      "Selling on your own? John's guide walks For Sale By Owner sellers through selling their home themselves, from a Realtor with 40+ years in New Jersey.",
    cover: fsboCover,
    coverWidth: 244,
    coverHeight: 380,
    readUrl: "https://johnmastroianni.book.live/read-fsbo-book",
    tag: "book-fsbo",
  },
  {
    key: "expired",
    title: "How I Sell Homes Others Failed to Sell",
    audience: "Expired Listings",
    description:
      "Listing expired? See how John approaches homes that didn't sell the first time, and what a fresh start can look like.",
    cover: expiredCover,
    coverWidth: 250,
    coverHeight: 376,
    readUrl: "https://johnmastroianni.book.live/read-expired-book",
    tag: "book-expired",
  },
  {
    key: "top-dollar",
    title: "How to Sell Homes Fast for Top Dollar",
    audience: "Sellers",
    description:
      "Discover the proven formula for generating maximum interest in your home so it sells for top dollar, fast.",
    cover: topDollarCover,
    coverWidth: 242,
    coverHeight: 378,
    readUrl: "https://johnmastroianni.book.live/read-biz-card-book",
    tag: "book-top-dollar",
  },
  {
    key: "buying",
    title: "Complete Guide to Buying a Home",
    audience: "Buyers",
    description:
      "Discover the strategies savvy buyers use to find their dream home and save on their purchase.",
    cover: buyingCover,
    coverWidth: 242,
    coverHeight: 370,
    readUrl: "https://johnmastroianni.book.live/read-buyer-book",
    tag: "book-buying",
  },
  {
    key: "downsize",
    title: "Ready to Downsize? A Real Estate Guide for Empty Nesters and Retirees",
    audience: "Empty Nesters & Retirees",
    description:
      "Discover everything you should know about downsizing your home: important things to consider, how to maximize your sale price, mistakes to avoid, and much more.",
    cover: downsizeCover,
    coverWidth: 986,
    coverHeight: 737,
    readUrl: "https://johnmastroianni.book.live/read-senior-book",
    tag: "book-downsize",
    spread: true,
  },
];

export const getBook = (key: BookKey) => BOOKS.find((b) => b.key === key)!;
